import { useMemo } from 'react'

import { AVAILABLE_QUANTITY } from '../EditPeriods/DatePickerPeriodSelector/hooks/useInventoryPeriods'
import { PRODUCT_PERIODS_DATES, QUANTITY } from '../../../../../../fields'

export const useCompetingPeriods = productValues => {
  const selectedQuantity = productValues[QUANTITY]
  const selectedPeriods = productValues[PRODUCT_PERIODS_DATES]

  const competingPeriods = useMemo(() => {
    if (selectedPeriods) {
      return selectedPeriods.filter(period => {
        const competingQuantity = period.competing_quotation?.competing_quotation_quantity

        if (competingQuantity) {
          // if there are any inventory periods where selected quantity on proposal + sum of quantity of
          // competing quotations is > available inventory for that period
          return competingQuantity + selectedQuantity > period[AVAILABLE_QUANTITY]
        } else {
          return false
        }
      })
    } else {
      return []
    }
  }, [selectedPeriods, selectedQuantity])

  const hasCompetingPeriods = competingPeriods.length > 0

  return useMemo(
    () => ({
      competingPeriods,
      hasCompetingPeriods
    }),
    [competingPeriods, hasCompetingPeriods]
  )
}

export default useCompetingPeriods
